import { Api } from 'api'
const offline_atlas = {
  namespaced: true,
  state: {
    nodeTree: {},
    nodeTreeCopy: {
      id: '17822186219117316526146',
      tenantId: '123456',
      mapId: '1782219818880593922',
      parentNodeId: '-1',
      nodeName: '模拟节点1',
      nodeType: 1,
      level: 0,
      mappingIds: '',
      mappingKeys: '',
      comment: '根节点',
      addingCount: '0',
      mappingCount: '1',
      children: [
        {
          id: '1782722170758273093122',
          tenantId: '123456',
          mapId: '1782219818880593922',
          parentNodeId: '1782216291173126146',
          nodeName: '模拟节点2',
          nodeType: 1,
          level: 1,
          mappingIds: '',
          mappingKeys: '',
          comment: '一级节点',
          addingCount: '0',
          mappingCount: '1',
          children: [
            {
              id: '17822174160868689917370',
              tenantId: '123456',
              mapId: '1782219818880593922',
              parentNodeId: '1782217075273093122',
              nodeName: '模拟节点3',
              nodeType: 1,
              level: 2,
              mappingIds: '',
              mappingKeys: '',
              comment: '二级节点3',
              addingCount: '0',
              mappingCount: '1',
              children: [
                {
                  id: '1782822177584734228481',
                  tenantId: '123456',
                  mapId: '1782219818880593922',
                  parentNodeId: '1782217416068681730',
                  nodeName: '模拟节点4',
                  nodeType: 1,
                  level: 3,
                  mappingIds: '',
                  mappingKeys: '',
                  comment: '三级节点1',
                  addingCount: '0',
                  mappingCount: '1',
                  children: [
                    {
                      id: '1784221741656506861110',
                      tenantId: '123456',
                      mapId: '178221741606861110',
                      parentNodeId: '1782217075273093122',
                      nodeName: '模拟节点5',
                      nodeType: 3,
                      level: 2,
                      mappingIds: '',
                      mappingKeys: '',
                      comment: '二级节点4',
                      addingCount: '0',
                      mappingCount: '1',
                      children: [
                        {
                          id: '178622175866497349228481',
                          tenantId: '123456',
                          mapId: '1782219818880593922',
                          parentNodeId: '1782217416068681730',
                          nodeName: '模拟节点6',
                          nodeType: 2,
                          level: 3,
                          mappingIds: '',
                          mappingKeys: '',
                          comment: '三级节点1',
                          addingCount: '0',
                          mappingCount: '1',
                          children: []
                        },
                        {
                          id: '178226236727758590861059',
                          tenantId: '123456',
                          mapId: '1782223625890861059',
                          parentNodeId: '1782217416068681730',
                          nodeName: '模拟节点7',
                          nodeType: 3,
                          level: 3,
                          mappingIds: '',
                          mappingKeys: '',
                          comment: '三级节点2',
                          addingCount: '0',
                          mappingCount: '1',
                          children: []
                        }
                      ]
                    }
                  ]
                },
                {
                  id: '17822236258905876861058',
                  tenantId: '123456',
                  mapId: '1782219818880593922',
                  parentNodeId: '1782217416068681730',
                  nodeName: '模拟节点8',
                  nodeType: 1,
                  level: 3,
                  mappingIds: '',
                  mappingKeys: '',
                  comment: '三级节点2',
                  addingCount: '0',
                  mappingCount: '1',
                  children: []
                }
              ]
            },
            {
              id: '178221741690068615110',
              tenantId: '123456',
              mapId: '178221741606861110',
              parentNodeId: '1782217075273093122',
              nodeName: '模拟节点9',
              nodeType: 1,
              level: 2,
              mappingIds: '',
              mappingKeys: '',
              comment: '二级节点4',
              addingCount: '0',
              mappingCount: '1',
              children: [
                {
                  id: '17822175846734228481',
                  tenantId: '123456',
                  mapId: '1782219818880593922',
                  parentNodeId: '1782217416068681730',
                  nodeName: '模拟节点10',
                  nodeType: 1,
                  level: 3,
                  mappingIds: '',
                  mappingKeys: '',
                  comment: '三级节点1',
                  addingCount: '0',
                  mappingCount: '1',
                  children: []
                },
                {
                  id: '17822723625890861059',
                  tenantId: '123456',
                  mapId: '1782223625890861059',
                  parentNodeId: '1782217416068681730',
                  nodeName: '模拟节点11',
                  nodeType: 1,
                  level: 3,
                  mappingIds: '',
                  mappingKeys: '',
                  comment: '三级节点2',
                  addingCount: '0',
                  mappingCount: '1',
                  children: []
                }
              ]
            },
            {
              id: '1478221741606861110',
              tenantId: '123456',
              mapId: '178221741606861110',
              parentNodeId: '1782217075273093122',
              nodeName: '模拟节点12',
              nodeType: 1,
              level: 2,
              mappingIds: '',
              mappingKeys: '',
              comment: '二级节点4',
              addingCount: '0',
              mappingCount: '1',
              children: [
                {
                  id: '51782217584734228481',
                  tenantId: '123456',
                  mapId: '1782219818880593922',
                  parentNodeId: '1782217416068681730',
                  nodeName: '模拟节点13',
                  nodeType: 1,
                  level: 3,
                  mappingIds: '',
                  mappingKeys: '',
                  comment: '三级节点1',
                  addingCount: '0',
                  mappingCount: '1',
                  children: []
                },
                {
                  id: '61782223625890861059',
                  tenantId: '123456',
                  mapId: '1782223625890861059',
                  parentNodeId: '1782217416068681730',
                  nodeName: '模拟节点14',
                  nodeType: 1,
                  level: 3,
                  mappingIds: '',
                  mappingKeys: '',
                  comment: '三级节点2',
                  addingCount: '0',
                  mappingCount: '1',
                  children: []
                }
              ]
            }
          ]
        },
        {
          id: '17822170752730193122',
          tenantId: '123456',
          mapId: '1782219818880593922',
          parentNodeId: '1782216291173126146',
          nodeName: '模拟节点15',
          nodeType: 1,
          level: 1,
          mappingIds: '',
          mappingKeys: '',
          comment: '一级节点',
          addingCount: '0',
          mappingCount: '1',
          children: [
            {
              id: '17822174216068681730',
              tenantId: '123456',
              mapId: '1782219818880593922',
              parentNodeId: '1782217075273093122',
              nodeName: '模拟节点16',
              nodeType: 4,
              level: 2,
              mappingIds: '',
              mappingKeys: '',
              comment: '二级节点3',
              addingCount: '0',
              mappingCount: '1',
              children: [
                {
                  id: '17822173847342284851',
                  tenantId: '123456',
                  mapId: '1782219818880593922',
                  parentNodeId: '1782217416068681730',
                  nodeName: '模拟节点17',
                  nodeType: 1,
                  level: 3,
                  mappingIds: '',
                  mappingKeys: '',
                  comment: '三级节点1',
                  addingCount: '0',
                  mappingCount: '1',
                  children: []
                },
                {
                  id: '1782223644258790861058',
                  tenantId: '123456',
                  mapId: '1782219818880593922',
                  parentNodeId: '1782217416068681730',
                  nodeName: '模拟节点18',
                  nodeType: 2,
                  level: 3,
                  mappingIds: '',
                  mappingKeys: '',
                  comment: '三级节点2',
                  addingCount: '0',
                  mappingCount: '1',
                  children: []
                }
              ]
            },
            {
              id: '178292174165506861110',
              tenantId: '123456',
              mapId: '178221741606861110',
              parentNodeId: '1782217075273093122',
              nodeName: '模拟节点19',
              nodeType: 3,
              level: 2,
              mappingIds: '',
              mappingKeys: '',
              comment: '二级节点4',
              addingCount: '0',
              mappingCount: '1',
              children: [
                {
                  id: '9178221758664734228481',
                  tenantId: '123456',
                  mapId: '1782219818880593922',
                  parentNodeId: '1782217416068681730',
                  nodeName: '模拟节点20',
                  nodeType: 2,
                  level: 3,
                  mappingIds: '',
                  mappingKeys: '',
                  comment: '三级节点1',
                  addingCount: '0',
                  mappingCount: '1',
                  children: []
                },
                {
                  id: '17822256362775890861059',
                  tenantId: '123456',
                  mapId: '1782223625890861059',
                  parentNodeId: '1782217416068681730',
                  nodeName: '模拟节点21',
                  nodeType: 3,
                  level: 3,
                  mappingIds: '',
                  mappingKeys: '',
                  comment: '三级节点2',
                  addingCount: '0',
                  mappingCount: '1',
                  children: []
                }
              ]
            },
            {
              id: '1782217416550683161110',
              tenantId: '123456',
              mapId: '178221741606861110',
              parentNodeId: '1782217075273093122',
              nodeName: '模拟节点22',
              nodeType: 3,
              level: 2,
              mappingIds: '',
              mappingKeys: '',
              comment: '二级节点4',
              addingCount: '0',
              mappingCount: '1',
              children: [
                {
                  id: '56178221758664734228481',
                  tenantId: '123456',
                  mapId: '1782219818880593922',
                  parentNodeId: '1782217416068681730',
                  nodeName: '模拟节点23',
                  nodeType: 2,
                  level: 3,
                  mappingIds: '',
                  mappingKeys: '',
                  comment: '三级节点1',
                  addingCount: '0',
                  mappingCount: '1',
                  children: [
                    {
                      id: '56717822174165506861110',
                      tenantId: '123456',
                      mapId: '178221741606861110',
                      parentNodeId: '1782217075273093122',
                      nodeName: '模拟节点24',
                      nodeType: 3,
                      level: 2,
                      mappingIds: '',
                      mappingKeys: '',
                      comment: '二级节点4',
                      addingCount: '0',
                      mappingCount: '1',
                      children: [
                        {
                          id: '678178221758664734228481',
                          tenantId: '123456',
                          mapId: '1782219818880593922',
                          parentNodeId: '1782217416068681730',
                          nodeName: '模拟节点25',
                          nodeType: 2,
                          level: 3,
                          mappingIds: '',
                          mappingKeys: '',
                          comment: '三级节点1',
                          addingCount: '0',
                          mappingCount: '1',
                          children: []
                        },
                        {
                          id: '507178222362775890861059',
                          tenantId: '123456',
                          mapId: '1782223625890861059',
                          parentNodeId: '1782217416068681730',
                          nodeName: '模拟节点26',
                          nodeType: 3,
                          level: 3,
                          mappingIds: '',
                          mappingKeys: '',
                          comment: '三级节点2',
                          addingCount: '0',
                          mappingCount: '1',
                          children: []
                        }
                      ]
                    }
                  ]
                },
                {
                  id: '67178222362775890861059',
                  tenantId: '123456',
                  mapId: '1782223625890861059',
                  parentNodeId: '1782217416068681730',
                  nodeName: '模拟节点27',
                  nodeType: 3,
                  level: 3,
                  mappingIds: '',
                  mappingKeys: '',
                  comment: '三级节点2',
                  addingCount: '0',
                  mappingCount: '1',
                  children: [
                    {
                      id: '817822174165506861110',
                      tenantId: '123456',
                      mapId: '178221741606861110',
                      parentNodeId: '1782217075273093122',
                      nodeName: '模拟节点28',
                      nodeType: 3,
                      level: 2,
                      mappingIds: '',
                      mappingKeys: '',
                      comment: '二级节点4',
                      addingCount: '0',
                      mappingCount: '1',
                      children: [
                        {
                          id: '2178221758664734228481',
                          tenantId: '123456',
                          mapId: '1782219818880593922',
                          parentNodeId: '1782217416068681730',
                          nodeName: '模拟节点29',
                          nodeType: 2,
                          level: 3,
                          mappingIds: '',
                          mappingKeys: '',
                          comment: '三级节点1',
                          addingCount: '0',
                          mappingCount: '1',
                          children: []
                        },
                        {
                          id: '33178222362775890861059',
                          tenantId: '123456',
                          mapId: '1782223625890861059',
                          parentNodeId: '1782217416068681730',
                          nodeName: '模拟节点30',
                          nodeType: 3,
                          level: 3,
                          mappingIds: '',
                          mappingKeys: '',
                          comment: '三级节点2',
                          addingCount: '0',
                          mappingCount: '1',
                          children: [
                            {
                              id: '74117822174165506861110',
                              tenantId: '123456',
                              mapId: '178221741606861110',
                              parentNodeId: '1782217075273093122',
                              nodeName: '模拟节点31',
                              nodeType: 3,
                              level: 2,
                              mappingIds: '',
                              mappingKeys: '',
                              comment: '二级节点4',
                              addingCount: '0',
                              mappingCount: '1',
                              children: [
                                {
                                  id: '36178221758664734228481',
                                  tenantId: '123456',
                                  mapId: '1782219818880593922',
                                  parentNodeId: '1782217416068681730',
                                  nodeName: '模拟节点32',
                                  nodeType: 2,
                                  level: 3,
                                  mappingIds: '',
                                  mappingKeys: '',
                                  comment: '三级节点1',
                                  addingCount: '0',
                                  mappingCount: '1',
                                  children: []
                                },
                                {
                                  id: '85178222362775890861059',
                                  tenantId: '123456',
                                  mapId: '1782223625890861059',
                                  parentNodeId: '1782217416068681730',
                                  nodeName: '模拟节点33',
                                  nodeType: 3,
                                  level: 3,
                                  mappingIds: '',
                                  mappingKeys: '',
                                  comment: '三级节点2',
                                  addingCount: '0',
                                  mappingCount: '1',
                                  children: [
                                    {
                                      id: '98717822174165506861110',
                                      tenantId: '123456',
                                      mapId: '178221741606861110',
                                      parentNodeId: '1782217075273093122',
                                      nodeName: '模拟节点34',
                                      nodeType: 3,
                                      level: 2,
                                      mappingIds: '',
                                      mappingKeys: '',
                                      comment: '二级节点4',
                                      addingCount: '0',
                                      mappingCount: '1',
                                      children: [
                                        {
                                          id: '1234178221758664734228481',
                                          tenantId: '123456',
                                          mapId: '1782219818880593922',
                                          parentNodeId: '1782217416068681730',
                                          nodeName: '模拟节点35',
                                          nodeType: 2,
                                          level: 3,
                                          mappingIds: '',
                                          mappingKeys: '',
                                          comment: '三级节点1',
                                          addingCount: '0',
                                          mappingCount: '1',
                                          children: []
                                        },
                                        {
                                          id: '547178222362775890861059',
                                          tenantId: '123456',
                                          mapId: '1782223625890861059',
                                          parentNodeId: '1782217416068681730',
                                          nodeName: '模拟节点36',
                                          nodeType: 3,
                                          level: 3,
                                          mappingIds: '',
                                          mappingKeys: '',
                                          comment: '三级节点2',
                                          addingCount: '0',
                                          mappingCount: '1',
                                          children: [
                                            {
                                              id: '87617822174165506861110',
                                              tenantId: '123456',
                                              mapId: '178221741606861110',
                                              parentNodeId: '1782217075273093122',
                                              nodeName: '模拟节点37',
                                              nodeType: 3,
                                              level: 2,
                                              mappingIds: '',
                                              mappingKeys: '',
                                              comment: '二级节点4',
                                              addingCount: '0',
                                              mappingCount: '1',
                                              children: [
                                                {
                                                  id: '178228901758664734228481',
                                                  tenantId: '123456',
                                                  mapId: '1782219818880593922',
                                                  parentNodeId: '1782217416068681730',
                                                  nodeName: '模拟节点38',
                                                  nodeType: 2,
                                                  level: 3,
                                                  mappingIds: '',
                                                  mappingKeys: '',
                                                  comment: '三级节点1',
                                                  addingCount: '0',
                                                  mappingCount: '1',
                                                  children: [
                                                    {
                                                      id: '1782217451655068651110',
                                                      tenantId: '123456',
                                                      mapId: '178221741606861110',
                                                      parentNodeId: '1782217075273093122',
                                                      nodeName: '模拟节点39',
                                                      nodeType: 3,
                                                      level: 2,
                                                      mappingIds: '',
                                                      mappingKeys: '',
                                                      comment: '二级节点4',
                                                      addingCount: '0',
                                                      mappingCount: '1',
                                                      children: [
                                                        {
                                                          id: '17782217586647834228481',
                                                          tenantId: '123456',
                                                          mapId: '1782219818880593922',
                                                          parentNodeId: '1782217416068681730',
                                                          nodeName: '模拟节点40',
                                                          nodeType: 2,
                                                          level: 3,
                                                          mappingIds: '',
                                                          mappingKeys: '',
                                                          comment: '三级节点1',
                                                          addingCount: '0',
                                                          mappingCount: '1',
                                                          children: [
                                                            {
                                                              id: '1578221741655066861110',
                                                              tenantId: '123456',
                                                              mapId: '178221741606861110',
                                                              parentNodeId: '1782217075273093122',
                                                              nodeName: '模拟节点41',
                                                              nodeType: 3,
                                                              level: 2,
                                                              mappingIds: '',
                                                              mappingKeys: '',
                                                              comment: '二级节点4',
                                                              addingCount: '0',
                                                              mappingCount: '1',
                                                              children: [
                                                                {
                                                                  id: '17782217586647834228481',
                                                                  tenantId: '123456',
                                                                  mapId: '1782219818880593922',
                                                                  parentNodeId: '1782217416068681730',
                                                                  nodeName: '模拟节点42',
                                                                  nodeType: 2,
                                                                  level: 3,
                                                                  mappingIds: '',
                                                                  mappingKeys: '',
                                                                  comment: '三级节点1',
                                                                  addingCount: '0',
                                                                  mappingCount: '1',
                                                                  children: []
                                                                },
                                                                {
                                                                  id: '16782223652775890861059',
                                                                  tenantId: '123456',
                                                                  mapId: '1782223625890861059',
                                                                  parentNodeId: '1782217416068681730',
                                                                  nodeName: '模拟节点43',
                                                                  nodeType: 3,
                                                                  level: 3,
                                                                  mappingIds: '',
                                                                  mappingKeys: '',
                                                                  comment: '最终节点',
                                                                  addingCount: '0',
                                                                  mappingCount: '1',
                                                                  children: []
                                                                }
                                                              ]
                                                            }
                                                          ]
                                                        },
                                                        {
                                                          id: '177872223627875890861059',
                                                          tenantId: '123456',
                                                          mapId: '1782223625890861059',
                                                          parentNodeId: '1782217416068681730',
                                                          nodeName: '模拟节点44',
                                                          nodeType: 3,
                                                          level: 3,
                                                          mappingIds: '',
                                                          mappingKeys: '',
                                                          comment: '三级节点2',
                                                          addingCount: '0',
                                                          mappingCount: '1',
                                                          children: []
                                                        }
                                                      ]
                                                    }
                                                  ]
                                                },
                                                {
                                                  id: '178222683627758490861059',
                                                  tenantId: '123456',
                                                  mapId: '1782223625890861059',
                                                  parentNodeId: '1782217416068681730',
                                                  nodeName: '模拟节点45',
                                                  nodeType: 3,
                                                  level: 3,
                                                  mappingIds: '',
                                                  mappingKeys: '',
                                                  comment: '三级节点2',
                                                  addingCount: '0',
                                                  mappingCount: '1',
                                                  children: []
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },

    gradeing: 10000,//10000 就是代表全部
    grades: [
      {
        value:10000,
        label:'全部'
      }
    ],
    isDownload: false,
    nodeDetailsVisible: false,
    nodeState: {
      visible: false,
      nodeType: 3,
      state:'add',//add 新增  edit 编辑
    },
    selectNode: null,//当前选中的节点
    addTalentVisible: false,
    selectMap: {
      id: '',
      mapName:'',
    },
    mapState: {
      visible: false,
      state:'add',//add 新增  edit 编辑
    },
    maps: [],
    fullScreen: false,
    updateRemarksVisible: false,
    aerialViewWidth: 200,
    aerialIsDrag:false
  },
  mutations: {
    SET_nodeTree(state, val) {
      state.nodeTree = val
    },
    SET_grades(state, val) {
      state.grades = val
    },
    SET_gradeing(state, val) {
      state.gradeing = val
    },
    SET_isDownload(state, val) {
      state.isDownload = val
    },
    SET_visible(state, val) {
      state.nodeDetailsVisible = val
    },
    SET_addTalentVisible(state, val) {
      state.addTalentVisible = val
    },
    SET_selectMap(state, val) {
      state.selectMap = val
    },
    SET_maps(state, val) {
      state.maps = val
    },
    SET_selectNode(state, val) {
      state.selectNode = val
    },
    SET_mapState(state, val) {
      state.mapState = val
    },
    SET_updateRemarksVisible(state, val) {
      state.updateRemarksVisible = val
    },
    SET_aerialIsDrag(state, val) {
      state.aerialIsDrag = val
    },
  },
  actions: {
    burialPoint({ commit, state }, data) { 
      return
      //后端已经埋点了，前端不用埋了
      Api.talentMapBurialPoint({
        ...data,
        mapId:state.selectMap.id
      })
    }
  }
}

export default offline_atlas
